import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ToggleGroupCard, ToggleGroupCardItem } from '@/components/ui/toggle-group';
import { EscrowPartyTypeEnum } from 'src/graphql/schema';

import { assetVisibilityOptionsRich } from '../model';

type Props = {
  onAssetVisibilityChange: (value: boolean | null) => void;
  assetVisibility: boolean;
  party: EscrowPartyTypeEnum;
};

const partyDescriptionMap = {
  [EscrowPartyTypeEnum.Beneficiary]: `Do you want to see the deposited assets?\nIf enabled, you will be able to manage your own notification settings.`,
  [EscrowPartyTypeEnum.Depositor]:
    'The depositor always has visibility into deposited assets — this controls whether the beneficiary can see them too. If enabled, the beneficiary will manage their own notification settings when they accept the invitation.',
};

const AssetVisibility = ({ onAssetVisibilityChange, assetVisibility, party }: Props) => {
  const onChange = (value: string) => onAssetVisibilityChange(value === '' ? null : value === 'true');

  return (
    <Card>
      <CardHeader className="pb-4">
        <CardTitle>Beneficiary asset visibility</CardTitle>
        <CardDescription className="whitespace-pre-wrap">{partyDescriptionMap[party]}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-2">
        <ToggleGroupCard
          type="single"
          orientation="horizontal"
          onValueChange={onChange}
          value={assetVisibility.toString()}
        >
          {assetVisibilityOptionsRich.map(({ value, icon: Icon, label, description }) => (
            <ToggleGroupCardItem key={value} value={value} icon={Icon} title={label} description={description} />
          ))}
        </ToggleGroupCard>
      </CardContent>
    </Card>
  );
};

export default AssetVisibility;
